import { __zcFin, __zcFinZ, __zcMkv } from "__zod-compiler-runtime__";
import * as z from 'zod'

// Naming follows the conventions established in the WebGL package.
// Ref: https://github.com/github/brand-refactor-webgl
export const BrandEnum = /* @__PURE__ */ (() => {
var __zs=z.enum(['Mona', 'Copilot', 'Security', 'General']);
function __fc_0(input){return (input==="Mona"||input==="Copilot"||input==="Security"||input==="General");}
var __rfm_z=__zs.safeParse;
function safeParse_BrandEnum(input){
if(__fc_0(input)){return{success:true,data:input};}
return __zcFinZ(__rfm_z,__zs,input);
}
return __zcMkv(safeParse_BrandEnum,__zs,__fc_0,__fc_0);
})()
export type Brand = z.infer<typeof BrandEnum>
